import { useEffect, useMemo } from "react";
import useProfiler from "../../../hooks/useProfiler.js";
import { createTrackingUtils } from "../index.js";
export const flights_funnel_sr_airport_highlight_web = createTrackingUtils({
    name: "flights_funnel_sr_airport_highlight_web",
    defaultStage: 1,
    stages: {
        main: 1,
        ddot: 2,
        mdot: 3,
        multicity: 4,
        all_airports_differ: 5,
        direct: 6,
        meta: 7
    },
    goals: {},
    goalsWithValue: []
});
export function useTrackFlightsFunnelSrAirportHighlightWeb(segments) {
    const { isDesktop, isMobile, isDirect, isMeta, isRountrip, isMultiStop } = useProfiler();
    const canTrack = useMemo(() => !!segments?.some?.((segment) => !!segment?.highlightDestinationAirport || !!segment?.highlightOriginAirport), [segments]);
    useEffect(() => {
        if (!canTrack)
            return;
        flights_funnel_sr_airport_highlight_web.stages.main();
        if (isDesktop())
            flights_funnel_sr_airport_highlight_web.stages.ddot();
        if (isMobile())
            flights_funnel_sr_airport_highlight_web.stages.mdot();
        if (isMultiStop())
            flights_funnel_sr_airport_highlight_web.stages.multicity();
        if (isDirect())
            flights_funnel_sr_airport_highlight_web.stages.direct();
        if (isMeta())
            flights_funnel_sr_airport_highlight_web.stages.meta();
        if (isRountrip()) {
            const isAllAirportsDiffer = new Set([
                segments?.[0]?.departureAirport?.code,
                segments?.[0]?.arrivalAirport?.code,
                segments?.[1]?.departureAirport?.code,
                segments?.[1]?.arrivalAirport?.code
            ]).size === 4;
            if (isAllAirportsDiffer)
                flights_funnel_sr_airport_highlight_web.stages.all_airports_differ();
        }
    }, [canTrack, isDesktop, isMobile, isDirect, isMeta, isMultiStop, isRountrip, segments]);
}
